import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { RestService } from '../../../services/rest/rest.service';
import { CommonService } from '../../../services/common/common.service';
import { HelpIndex, Endpoint, UpdateStatusType } from '../../../models/enums';
import * as _ from 'underscore';
import { NewDataSetLoadFileMenuComponent } from '../../new-data-set-load-file-menu/new-data-set-load-file-menu.component';
import { XMLService } from '../../../services/xml/xml.service';
import { DrObject } from '../../../models/dr-object';
import { ActionType, ObjectActionListType, Permissions } from '../../../models/permission';
import { IndexLevel } from '../../../models/index-settings';

@Component({
    standalone: false,
    selector: 'res-create-dataset-from-search-result-modal',
    templateUrl: './create-dataset-from-search-result-modal.component.html',
    styleUrls: ['./create-dataset-from-search-result-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CreateDatasetFromSearchResultModalComponent extends BaseModalComponent implements OnInit {
    @ViewChild(NewDataSetLoadFileMenuComponent, { static: true }) menuComponent: NewDataSetLoadFileMenuComponent;
    readonly IndexLevel = IndexLevel;
    modalTitle = 'Create Data Set from Search Results';
    modalClass = 'create-dataSet-from-search-result';
    modalAutomationId = 'create-data-set-from-search-results';
    modalHelpIndex = HelpIndex.create_dataset_from_result_dlg;
    primaryButtonLabel = 'Create Data Set';
    secondaryButtonLabel = 'Cancel';
    documentCounts: number;
    queryStr: string;
    isBusy = false;
    isBusyMessage = 'Loading ...';
    hasAddToProjectPermissions = true;
    addToProjectData = false;

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private restService: RestService,
        private xmlService: XMLService,
        private commonService: CommonService) {
        super(modalService, modalRef);
    }

    ngOnInit() {
        if (this.modalData) {
            this.documentCounts = this.modalData.documentCount;
            // get the Query String here.
            if (this.modalData.task === 'VECTOR_SET_SEARCH') {
                this.restService.post(Endpoint.taskManager_getTasks, {
                    taskHandles: [this.modalData.handle],
                    includeDrDebug: true,
                    includeResourceStatistics: true
                }).then(response => {
                    if (response.tasks && response.tasks.length > 0) {
                        this.queryStr = response.tasks[0].description;
                        this.queryStr = this.xmlService.stripExtraneousParens(this.queryStr);
                        this.queryStr = !this.commonService.currentBrowserIsIE ? (window as any).hljs?.highlightAuto(this.queryStr).value : this.queryStr;
                    }
                });
            }
        }
        this.hasAddToProjectPermissions = Permissions.checkUserPermissions([{ permissionType: ObjectActionListType.ECA_CASE_DATA, permissionActions: [ActionType.CREATE] }]);
    }

    ok() {
        this.isBusy = true;
        this.restService.post(Endpoint.orgManager_createCorpus, {
            attributes: [{ name: 'projecthandle', value: this.commonService.currentProject.handle }],
            brand: true,
            description: this.menuComponent.nameDescriptionComponent.description,
            name: this.menuComponent.nameDescriptionComponent.name,
            viewHandles: [this.modalData.handle]
        }).then(createCorpusResponse => {
            this.restService.post(Endpoint.projectManager_listCorpusSets, {
                projectHandle: this.commonService.currentProject.handle,
                count: 1,
                startIndex: 0
            }).then(listCorpusSetsResponse => {
                this.restService.post(Endpoint.corpusSetManager_addCorpus, {
                    corpusHandle: createCorpusResponse.corpus.handle,
                    corpusSetHandle: listCorpusSetsResponse.corpusSets[0].handle
                }).then(() => {
                    const indexSettings = this.menuComponent.getIndexLevelSetting();
                    this.restService.post(Endpoint.corpusManager_createRepresentation, {
                        attributes: [{ name: 'projecthandle', value: this.commonService.currentProject.handle }],
                        corpusHandle: createCorpusResponse.corpus.handle,
                        scanAttributes: [{ name: 'batchNumber', value: this.menuComponent.batchName?.trim() }],
                        taskDescription: 'Creating representation ' + indexSettings.name + ' for ' + this.menuComponent.nameDescriptionComponent.name,
                        typeList: indexSettings.indexLevelSetting,
                        enablePatternDetection: this.menuComponent.isPatternDetectionEnabled
                    }, true, true).then(representationResponse => {
                        if (representationResponse && representationResponse.taskHandle && this.addToProjectData) {
                            this.restService.post(Endpoint.viewManager_addFromView, {
                                filterSrcDuplicates: false,
                                includeFamilyMembers: false,
                                destViewHandle: this.commonService.projectData.handle,
                                srcViewHandle: createCorpusResponse.corpus.corpusViewHandle,
                                taskDescription: 'Adding documents to Project Data',
                            });
                        }
                        this.isBusy = false;
                    }, error => {
                        this.isBusy = false;
                    });
                }, error => {
                    this.isBusy = false;
                });
            });
        }, error => {
            this.isBusy = false;
        });
        this.isBusy = false;
        this.closeModal(true, { name: this.menuComponent.nameDescriptionComponent.name, entityType: UpdateStatusType.CORPUS });
    }

    isPrimaryButtonEnabled() {
        let enabled = false;
        if (!DrObject.isEmpty(this.menuComponent.nameDescriptionComponent.name)) {
            if (this.menuComponent.nameDescriptionComponent.isNameDirty() && (this.menuComponent.nameDescriptionComponent.formValid)) {
                enabled = true;
            }

            if ((enabled === false) && (this.menuComponent.nameDescriptionComponent.isDescriptionDirty()) && (this.menuComponent.nameDescriptionComponent.formValid)) {
                enabled = true;
            }

            // TODO: there should be work to determine if the selected node is dirty see isTargetPickerDirty() in comparison
            if (!this.menuComponent.nameDescriptionComponent.isDescriptionDirty() && !this.menuComponent.nameDescriptionComponent.isNameDirty()) {
                enabled = true;
            }
        }
        return enabled;
    }
}
